import { LineChartIcon } from "@/assets/icons";

const NoDataWidgetContent = () => {
  return (
    <div className="flex flex-col gap-4 justify-center items-center">
      <div className="w-20 h-20 bg-whisper rounded-lg rotate-12 shadow-[0px_4px_24px_5px_#CECECE66] flex justify-center items-center">
        <LineChartIcon className="w-8 h-8 fill-dim-gray -rotate-12" />
      </div>
      <p className="text-txtPlaceholder font-semibold">
        Build your visualization
      </p>
      <span className="text-sm text-txtPlaceholder">
        Configure your chart by selecting a data source
      </span>
    </div>
  );
};

export default NoDataWidgetContent;
